import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import PerformancePage from "./pages/PerformancePage";
import ContactPage from "./pages/ContactPage";
import DonatePage from "./pages/DonatePage";
import TeamYearPage from "./pages/TeamYearPage";

import HowWeHelpPage from "./pages/HowWeHelpPage";
import FirstGlobalChallengePage from "./pages/FirstGlobalChallengePage";
import FGCNationals2026Page from "./pages/FGCNationals2026Page";
import BlogsRssPage from "./pages/BlogsRssPage";
import BlogPostDetailPage from "./pages/BlogPostDetailPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  return (
    <div className="App bg-cream min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/performance" element={<PerformancePage />} />
          <Route path="/how-we-help" element={<HowWeHelpPage />} />
          <Route path="/first-global-challenge" element={<FirstGlobalChallengePage />} />
          <Route path="/fgc-nationals-2026" element={<FGCNationals2026Page />} />
          <Route path="/performance/:year" element={<TeamYearPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/blogs" element={<BlogsRssPage />} />
          <Route path="/blogs/:slug" element={<BlogPostDetailPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
